import React, { FC } from 'react';
import { AgisticsSelect } from '../../../shared/agistics-select';
import { useOrganizationQuery } from '../../../../api/queries/use-organization-query';
import { OrganizationLocation } from '../../../../types';
import { OrgQueryKeys } from '../../../../api/config';
import { toSiteDisplayNameFromOrganizationLocation } from '../../../../utils/data-mapping';
import { L } from 'harmony-language';

interface HomeLocationSelectProps {
    homeLocationId: number | null | undefined;
    onChange: (homeLocationId: number | null) => void;
}

export const HomeLocationSelect: FC<HomeLocationSelectProps> = (props) => {
    const { homeLocationId, onChange } = props;
    const { data: organizationLocations = [], isSuccess } = useOrganizationQuery<OrganizationLocation[]>(OrgQueryKeys.locations);

    const organizationLocationItems = organizationLocations.map(organizationLocation => ({
        id: organizationLocation.id,
        value: toSiteDisplayNameFromOrganizationLocation(organizationLocation),
    }));

    return (
        isSuccess && <AgisticsSelect
            item={homeLocationId ? homeLocationId : null}
            items={organizationLocationItems}
            label={L.homeLocation()}
            onChange={(id) => {
                onChange(id === -1 ? null : id);
            }}
            showNone={true}
        />
    );
};
